import bags from "../../images/Products/bags_big.jpg";
import sweatdress from "../../images/Products/sweatdress.jpg";
import womendress from "../../images/Products/womendress.jpg";
import sexytshirt from "../../images/latestproducts/sexy_tshirt.jpg";
import sleevedress from "../../images/latestproducts/Sleeve-dresse.jpg";
import workoutspants from "../../images/latestproducts/Workout-Pants.jpg";
import skagenwatch from "../../images/latestproducts/Skagen-watch.jpg";

const WomenProducts = [
  {
    image: bags,
    name: " Big bag for Women ",
    price: "$15.00 USD",
  },
  {
    image: sweatdress,
    name: "Sweater dresses ",
    price: "$88.00 USD",
  },
  {
    image: womendress,
    name: "Women dresse",
    price: "$100.00 USD",
  },
  {
    image: sexytshirt,
    name: " sexy women T-shirt ",
    price: "$20.00 USD",
  },
  {
    image: sleevedress,
    name: "sleeve dresse",
    price: "$24.00 USD",
  },
  {
    image: workoutspants,
    name: "workouts pants",
    price: "$19.99 USD",
  },
  {
    image: skagenwatch,
    name: "cool skagen watch",
    price: "$14.00 USD",
  },
];

export default WomenProducts;
